import React from 'react';
import Spinner from '../ui/Spinner';
import TrocaIcone from '../ui/TrocaIcone';

interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  icon?: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
}

export default function PrimaryButton({
  children,
  onClick,
  type = 'button',
  disabled = false,
  loading = false,
  fullWidth = false,
  icon,
  variant = 'primary',
  className = '',
}: PrimaryButtonProps) {
  const baseStyles = `
    inline-flex items-center justify-center gap-2
    px-6 py-3.5
    text-sm font-semibold tracking-wide
    rounded-button
    transition-[background-color,box-shadow,transform,opacity] duration-300 ease-soft
    focus:outline-none focus:ring-2 focus:ring-offset-2
    active:scale-[0.97]
    disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100
  `;

  const variants: Record<string, string> = {
    primary: `
      bg-blush-500 text-white
      hover:bg-blush-600 hover:shadow-glow-blush
      focus:ring-blush-300
    `,
    secondary: `
      bg-sage-100 text-sage-700
      hover:bg-sage-200 hover:shadow-soft-md
      focus:ring-sage-300
    `,
    outline: `
      border-2 border-blush-200
      hover:bg-blush-50 hover:border-blush-300
      focus:ring-blush-200
    `,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        ${baseStyles}
        ${variants[variant]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
    >
      {/* Ícone e spinner ocupam a MESMA caixa. Antes era um ternário: sem ícone,
          o spinner aparecia do nada e empurrava o rótulo no meio do envio. */}
      {(loading || icon) && (
        <TrocaIcone
          ativo={loading}
          quandoAtivo={<Spinner className="w-4 h-4" label="Enviando" />}
          quandoInativo={icon}
        />
      )}
      {children}
    </button>
  );
}
